export default __webpack_public_path__ + "static/1247-205d0155d441eba0c615d31d489e8195.gif";